import classNames from 'classnames';

interface ColumnProps {
  mobile?: number;
  tablet?: number;
  desktop?: number;
  widescreen?: number;
  children?: React.ReactNode | React.ReactNode[];
  desktopOffset?: number;
}

const Column: React.FC<ColumnProps> = ({
  mobile,
  tablet,
  desktop,
  widescreen,
  children,
  desktopOffset
}) => {
  const classes = classNames({
    [`zb-column-is-mobile-${mobile}`]: mobile,
    [`zb-column-is-tablet-${tablet}`]: tablet,
    [`zb-column-is-desktop-${desktop}`]: desktop,
    [`zb-column-is-widescreen-${widescreen}`]: widescreen,
    [`zb-column-is-offset-${desktopOffset}`]: desktopOffset
  });

  return <div className={classes}>{children}</div>;
};

export default Column;
